import React, {useEffect, useState, Fragment} from 'react';
import {Link} from 'react-router-dom';
import './grade.css';

const GradeDetailModal = ({isOpen, onClose, gradeData}) => {
    if (!isOpen || !gradeData) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{gradeData.GMNAME}</h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <div className="detail-row">
                        <label>과목코드</label>
                        <span className="course-code">{gradeData.GMCODE}</span>
                    </div>
                    <div className="detail-row">
                        <label>이수구분</label>
                        <span className="type-badge">{gradeData.ISUGBN_NM}</span>
                    </div>
                    <div className="detail-row">
                        <label>학점</label>
                        <span className="credit-value">{gradeData.HAKJUM}</span>
                    </div>
                    <div className="detail-row">
                        <label>교수</label>
                        <span>{gradeData.GYOSUNM}</span>
                    </div>
                    <div className="detail-row">
                        <label>분반</label>
                        <span>{gradeData.BUNBAN}</span>
                    </div>
                    <div className="detail-row">
                        <label>환산점수</label>
                        <span className={`score-value ${gradeData.HWANSAN_GRADE ? 'has-score' : 'no-score'}`}>
                            {gradeData.HWANSAN_GRADE || '-'}
                        </span>
                    </div>
                    <div className="detail-row">
                        <label>비고</label>
                        {gradeData.BIGO ? (
                            <span className="note-badge">{gradeData.BIGO}</span>
                        ) : (
                            <span className="no-note">-</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const GradePage = () => {
    const [token, setToken] = useState('');
    const [result, setResult] = useState([]);
    const [resultHakgi, setResultHakgi] = useState({});
    const [selectedGrade, setSelectedGrade] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleRowClick = (gradeData) => {
        setSelectedGrade(gradeData);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedGrade(null);
    };

    useEffect(() => {
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');
        if (storedToken) setToken(storedToken);

        fetch(`/backend/hakgi_info?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(setResultHakgi)
            .catch(console.error);
    }, []);

    useEffect(() => {
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');
        if (storedToken) setToken(storedToken);

        fetch(`/backend/grade?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(setResult)
            .catch(console.error);
    }, []);

    return (
        <div className="App App-header gnb_b" id="grade">
            <header>
                <div className="gnb_1">
                    <Link className="gnb_logo" to="/"></Link>
                </div>
            </header>
            <div className="body">
                <div className="main_box_gnbs">
                    <span>성적 조회</span>
                    <span>{resultHakgi?.YEAR}년 {resultHakgi?.HAKGI}학기 [{resultHakgi?.HAKBUN}]</span>
                </div>
                
                <div className="menubox">
                    {result.length > 0 ? (
                        <div className="grade-table-container">
                            <div className="grade-table">
                                <div className="table-header">
                                    <div className="header-cell course">과목명</div>
                                    <div className="header-cell type">이수구분</div>
                                    <div className="header-cell credit">학점</div>
                                </div>
                                
                                {result.map((row, index) => (
                                    <div 
                                        key={index} 
                                        className="table-row clickable"
                                        onClick={() => handleRowClick(row)}
                                    >
                                        <div className="table-cell course">
                                            <div className="course-info">
                                                <div className="course-name">{row.GMNAME}</div>
                                                <div className="course-code-sub">({row.GMCODE})</div>
                                            </div>
                                        </div>
                                        <div className="table-cell type">
                                            <span className="type-badge">{row.ISUGBN_NM}</span>
                                        </div>
                                        <div className="table-cell credit">
                                            <span className="credit-value">{row.HAKJUM}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="no-data">
                            <div className="no-data-icon">📋</div>
                            <div className="no-data-message">조회된 성적이 없습니다</div>
                            <div className="no-data-sub">현재 학기에 등록된 과목이 없거나 성적이 아직 입력되지 않았습니다.</div>
                        </div>
                    )}
                </div>
                
                <div className="grade-notice">
                    <div className="notice-content">
                        <div className="notice-title">성적 조회 안내</div>
                        <div className="notice-list">
                            <div className="notice-item">• 과목을 클릭하면 상세 정보를 확인할 수 있습니다</div>
                            <div className="notice-item">• 현재 학기 성적 조회만 가능합니다</div>
                            <div className="notice-item">• 타 학기 성적은 인트라넷에서 확인해주세요</div>
                        </div>
                    </div>
                </div>

                <GradeDetailModal 
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    gradeData={selectedGrade}
                />
            </div>
        </div>
    );
};

export default GradePage;
